import React, { Component } from "react";
//import { Button } from "react-bootstrap";

class Start_Quiz extends Component<any, any> {
  /*constructor(props: any) {
    super(props);
  }*/

  render() {
    // <div className="col-lg-6 col-md-6">
    //   <div className="btn-history">
    //     <button className="btn qhistory-btn mb-5 ml-auto" type="submit">
    //       <i className="fas fa-angle-right"></i>&nbsp;Quiz History
    //     </button>
    //   </div>
    // </div>;

    return (
      <>
        <div className="main-section module-custom-main" id="right-container">
          <div className="col-lg-12 col-md-12">
            <div className="container">
              <div className="row mb-3">
                <div className="col-lg-6 col-md-6">
                  <div className="quiz-title">Take A Quiz</div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 fl-quiz">
                <div className="i-image"></div>
                <div className="arrow-down"></div>
                <div className="key-div">Key Info</div>
                <div className="f-box">
                  <div className="f-box-div">
                    <span className="f-span">Each quiz contains:</span>
                    <ul className="f-content">
                      <li>80 Multiple Choice questions.</li>
                      <li>
                        An option to review your answers at the end of the quiz.
                      </li>
                      <li>
                        Pass Mark: <strong>85%</strong>
                      </li>
                      <li>
                        Time Limit: <strong>60 mins</strong>
                      </li>
                      {/* <ul className="start-quiz-li-2">
                        <li className="start-quiz-div">
                          <div className="start-quiz-text">
                            <a href="/student/quiz-history">Quiz History</a>
                          </div>
                        </li>
                      </ul> */}
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 fl-quiz">
                <div className="g-image "></div>
                <div className="arrow-down"></div>
                <div className="guide-div">Study Guide</div>
                <div className="s-box">
                  <div className="s-box-div">
                    <span>
                      In order to prepare for these quizzes we recommend that
                      you:
                    </span>
                    <ul className="s-guide-points">
                      <li>
                        Read and revise the{" "}
                        <b>
                          <a
                            className="quiz-anchor"
                            target="_blank"
                            href="https://www.scrumguides.org/scrum-guide.html"  rel="noreferrer" 
                          >
                            Scrum Guide
                          </a>
                        </b>
                      </li>
                      <li>
                        Review the{" "}
                        <b>
                          <a className="quiz-anchor" href="/student/modules">
                            Training Modules
                          </a>
                        </b>
                        <br />
                        available exclusively on the portal.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 fl-quiz">
                <div className="q-image"></div>
                <div className="arrow-down"></div>
                <div className="tips-div">Quiz Tips</div>
                <div className="t-box">
                  <div className="t-box-div">
                    <ul className="quiz-tips-points">
                      <li>Ensure you are relaxed.</li>
                      <li>Take your time.</li>
                      <li>Carefully read each question.</li>
                      <li>
                        Pay attention on wordings (may, not, must and can).
                      </li>
                    </ul>
                    <ul className="start-quiz-li">
                      <li className="start-quiz-div">
                        <div className="start-quiz-text">
                          <a href="/student/quiz" onClick={()=>{localStorage.removeItem('flagQuestions')}}>Start Quiz</a>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Start_Quiz;
